// Generated by TaroBase SDK Generator: 2026-07-24T09:46:28.100Z
// Collection: chatMessages/$messageId
// Edits may be overwritten by subsequent runs!

import {
  get, getMany, set, subscribe, getFiles, setFile, runQuery, count, aggregate, transformValues,
  Time, Token, Increment, Address, PublicKey,
  TimeOperation, IncrementOperation, TokenAmount, AddressType,
  TarobaseMetadata, DocumentOperation, FileItem, setMany, formatError,
} from '../db-client';
import type { AggregateResult, AggregateOperation } from '../db-client';

/**
 * Chat thread between a renter and an agent. Renter writes their own 'user' messages; the backend (signing as PROJECT_VAULT_ADDRESS) writes 'agent' and 'system' messages after running the AI. Real-time subscriptions supported.
 */

export interface ChatMessagesRequest {
  sessionId: string;
  agentId: string;
  renterWallet: AddressType;
  sender: string;
  content: string;
  createdAt: number | TimeOperation | IncrementOperation | TokenAmount;
}

export interface ChatMessagesResponse {
  sessionId: string;
  agentId: string;
  renterWallet: string;
  sender: string;
  content: string;
  createdAt: number;
  id: string;
  tarobase_created_at: number;
}

/**
 * Build a ChatMessages operation for use with setMany.
 * @returns A DocumentOperation that can be passed to setMany.
 */
export function buildChatMessages(messageId: string, data: ChatMessagesRequest): DocumentOperation {
  const doc = transformValues(data);
  return { path: `chatMessages/${messageId}`, document: doc };
}

/**
 * The renter can create their own 'user' messages (caller must equal @newData.renterWallet). The backend, signing as PROJECT_VAULT_ADDRESS, creates 'agent' and 'system' messages after running the AI. sender is one of 'user' | 'agent' | 'system'. createdAt is Unix seconds. (Create/Update Single Item)
 * @returns A boolean indicating whether the operation succeeded (true) or failed (false). Always check this value to confirm the write worked.
 */
export async function setChatMessages(messageId: string, data: ChatMessagesRequest): Promise<boolean> {
  try {
    const transformedData = transformValues(data);
    const succeeded = await set(`chatMessages/${messageId}`, transformedData);
    return !!succeeded;
  } catch (error) {
    console.error(`Error setting ChatMessages: ${formatError(error)}`);
    return false;
  }
}

/**
 * 
  Read Operation Details: Only the renter who owns the thread (@data.renterWallet) or the backend vault (PROJECT_VAULT_ADDRESS) can read messages. Supports real-time subscriptions.
   (Get Single Item)
 */
export async function getChatMessages(messageId: string): Promise<ChatMessagesResponse | null> {
  try {
    const result = await get(`chatMessages/${messageId}`);
    return result as ChatMessagesResponse | null;
  } catch (error) {
    console.error(`Error getting ChatMessages: ${formatError(error)}`);
    return null;
  }
}

/**
 * Subscribes to changes in a single ChatMessages document. (
  Read Operation Details: Only the renter who owns the thread (@data.renterWallet) or the backend vault (PROJECT_VAULT_ADDRESS) can read messages. Supports real-time subscriptions.
  )
 */
export function subscribeChatMessages(callback: (data: ChatMessagesResponse | null) => void, messageId: string): Promise<() => Promise<void>> {
  return subscribe(`chatMessages/${messageId}`, { // Use the item's basePath
    onData: (data) => {
      callback(data as ChatMessagesResponse | null);
    },
    onError: (error) => {
      console.error(`Error subscribing to ChatMessages at path '${`chatMessages/${messageId}`}': ${formatError(error)}`);
    }
  });
}

/**
 * Get many ChatMessages items from collection chatMessages
 
  Read Operation Details: Only the renter who owns the thread (@data.renterWallet) or the backend vault (PROJECT_VAULT_ADDRESS) can read messages. Supports real-time subscriptions.
  
 */
export async function getManyChatMessages(filter: string = ""): Promise<ChatMessagesResponse[]> {
  try {
    const results = await get("chatMessages", { prompt: filter });
    return Array.isArray(results) ? results as ChatMessagesResponse[] : [];
  } catch (error) {
    console.error(`Error getting ChatMessages collection at path 'chatMessages': ${formatError(error)}`);
    return [];
  }
}

/**
 * Subscribe to changes in ChatMessages collection at chatMessages
 
  Read Operation Details: Only the renter who owns the thread (@data.renterWallet) or the backend vault (PROJECT_VAULT_ADDRESS) can read messages. Supports real-time subscriptions.
  
 */
export function subscribeManyChatMessages(callback: (data: ChatMessagesResponse[]) => void, filter: string = ""): Promise<() => Promise<void>> {
  return subscribe("chatMessages", {
    prompt: filter,
    onData: (data) => {
      callback(Array.isArray(data) ? data as ChatMessagesResponse[] : []);
    },
    onError: (error) => {
       console.error(`Error subscribing to ChatMessages collection at path '${"chatMessages"}': ${formatError(error)}`);
    }
  });
}

/**
 * Get all ChatMessages items from collection chatMessages
 
  Read Operation Details: Only the renter who owns the thread (@data.renterWallet) or the backend vault (PROJECT_VAULT_ADDRESS) can read messages. Supports real-time subscriptions.
  
 */
export async function getAllChatMessages(filter: string = ""): Promise<ChatMessagesResponse[]> {
  try {
    const results = await get("chatMessages", { prompt: filter });
    return Array.isArray(results) ? results as ChatMessagesResponse[] : [];
  } catch (error) {
    console.error(`Error getting ChatMessages collection at path 'chatMessages': ${formatError(error)}`);
    return [];
  }
}

/**
 * Subscribe to changes in ChatMessages collection at chatMessages
 
  Read Operation Details: Only the renter who owns the thread (@data.renterWallet) or the backend vault (PROJECT_VAULT_ADDRESS) can read messages. Supports real-time subscriptions.
  
 */
export function subscribeAllChatMessages(callback: (data: ChatMessagesResponse[]) => void, filter: string = ""): Promise<() => Promise<void>> {
  return subscribe("chatMessages", {
    prompt: filter,
    onData: (data) => {
      callback(Array.isArray(data) ? data as ChatMessagesResponse[] : []);
    },
    onError: (error) => {
       console.error(`Error subscribing to ChatMessages collection at path '${"chatMessages"}': ${formatError(error)}`);
    }
  });
}

